import React, { useContext } from "react";
import styled from "styled-components";

import * as colors from "../../styles/colors";
import { parseMarkdownLinks } from "./parseMarkdownLinks";
import { CrownPriceContext } from "./MdxProvider";

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 12px 0;
`;

const ListItem = styled.li`
  position: relative;
  padding-left: 20px;
  margin-bottom: 10px;
  font-size: 16px;
  color: ${colors.text};
  line-height: 170%;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 10px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${colors.primary};
  }
`;

export function BulletList({ items, children }) {
  const crownPrice = useContext(CrownPriceContext);
  const opts = { crownPrice };
  if (items) {
    return (
      <List>
        {items.map((item, i) => (
          <ListItem key={i}>{parseMarkdownLinks(item, opts)}</ListItem>
        ))}
      </List>
    );
  }

  return <List>{children}</List>;
}

export function BulletListItem({ children }) {
  return <ListItem>{children}</ListItem>;
}
